<template lang="pug">
  #portfolio
    section.section
      .container
        .title.is-4 Portfolio
        .columns
          Col(:m=4 :s=6 :xs=12  v-for="(item, index) in projects" :key="index")
            .columns(v-for="i in item")
              Project(:detailProject="i")
</template>

<script>
import { ps } from '../data/data.json'
import Project from '@/components/Project'
import Col from '@/components/Col'

export default {
  name: 'Portfolio',
  components: {
    Project,
    Col
  },
  data () {
    return {
      projects: [],
      colNum: null
    }
  },
  mounted () {
    this.getColNum()
    window.addEventListener('resize', this.getColNum)
    this.splitPs()
  },
  methods: {
    getColNum () {
      let windowSize = window.innerWidth
      if (windowSize > 1010) {
        this.colNum = 12 / 4
      } else if (windowSize > 768 && windowSize <= 1010) {
        this.colNum = 12 / 6
      } else {
        this.colNum = 12 / 12
      }
      this.splitPs()
    },
    splitPs () {
      this.projects = []
      const psLen = ps.length / this.colNum
      for (let i = 0; i < this.colNum; i += 1) {
        this.projects.push(ps.slice(i * psLen, i * psLen + psLen))
      }
    }
  }
}
</script>

<style lang="sass" scoped>
*
  // color: #fff
#portfolio
  padding-top: 5vh
  // background: linear-gradient(rgba(#1A1919,0.95), rgba(#222,0.95))
  background-color: #f8f8f8
.container
  min-height: 30vh
  .columns .column .columns
    padding: 10px .6em
</style>



// WEBPACK FOOTER //
// src/section/Portfolio.vue